/* eslint-disable */
import React, { useContext, useState } from 'react';
import { IconButton, Box, Typography, TextField, Checkbox, FormControlLabel } from '@mui/material';

import { useHistory } from 'react-router-dom';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import InputAdornment from '@mui/material/InputAdornment';

import UserContext from '../../Shared/UserContext';
import { loginUser, changeFirstPassword } from './LoginService';
import { resetLogin } from '../../Shared/UserContext/Actions';
import Input from '../../Shared/Input';
import useForm from '../../hooks/useForm';
import RenderOnDemandThenHide from '../RenderOnDemandThenHide';

import AuthLayout from '../../Shared/AuthLayout';
import AuthCard from '../../Shared/AuthCard';
import AuthButton from '../../Shared/UI/AuthButton';
import eyeicon from '../Login//icons/eyeicon.png'


/* ── Shared input field with label above ─────────────────────────── */
const fieldSx = {
  width: '100%',
  maxWidth: '740px',
  '& .MuiOutlinedInput-root': {
    width: '100%',
    height: '63px',
    backgroundColor: '#F8FAFC',
    borderRadius: '8px',
    fontSize: '15px',
    opacity: 1,
    '& fieldset': { borderColor: '#DEE5EE', borderWidth: '1px' },
    '&:hover fieldset': { borderColor: '#007BC6' },
    '&.Mui-focused fieldset': { borderColor: '#007BC6', borderWidth: '2px' },
  },
};

const LabeledField = ({ label, children }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%',mt:'-32px' }}>
    <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#8397AE',fontFamily:'Opens Sans' ,mt:'16px'}}>
      {label}
    </Typography>
    {children}
  </Box>
);

/* ── Change-password sub-form ────────────────────────────────────── */
const InputPassword = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Input
      {...props}
      type={showPassword ? 'text' : 'password'}
      margin="dense"
      iconEnd={
        <IconButton onClick={() => setShowPassword(!showPassword)} onMouseDown={(e) => e.preventDefault()} edge="end">
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      }
    />
  );
};

export const ChangePasswordForm = ({ values, onChange }) => (
  <Box marginTop="50px" width="100%">
    <InputPassword value={values.currentPassword} onChange={onChange} name="currentPassword" label="Mot de passe actuel :" />
    <InputPassword value={values.newPassword}      onChange={onChange} name="newPassword"      label="Nouveau Mot de passe :" />
    <InputPassword value={values.newPassword2}     onChange={onChange} name="newPassword2"     label="Confirmer Nouveau Mot de passe :" />
  </Box>
);

const ChangePassword = () => {
  const history = useHistory();
  const { onChange, values } = useForm({ currentPassword: '', newPassword: '', newPassword2: '' });
  const { dispatch, state: { firstLogin } } = useContext(UserContext);

  const onSubmit = async (e) => {
    e.preventDefault();
    await changeFirstPassword(dispatch, { oldPassword: values.currentPassword, newPassword: values.newPassword }, history, firstLogin.tmpUser, firstLogin.tmpToken);
  };

  const isValide = values.currentPassword && values.newPassword !== '' && values.newPassword === values.newPassword2;

  return (
    <>
      <ChangePasswordForm values={values} onChange={onChange} />
      <div style={{ width: '100%', borderTop: '2px solid #CCCCCC', margin: '20px 0 35px' }} />
      <AuthButton disabled={!isValide} onClick={onSubmit} type="submit">Sauvegarder</AuthButton>
    </>
  );
};

/* ── Main Login component ────────────────────────────────────────── */
const Login = () => {
  const history = useHistory();

  const { dispatch, state: { status, errorMessage, firstLogin } } = useContext(UserContext);

  const hasError = status === 'error';

  const [values, setValues] = useState({ username: '', password: '', showPassword: false, rememberMe: false });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: prop === 'rememberMe' ? event.target.checked : event.target.value });
    if (hasError && prop !== 'rememberMe') dispatch(resetLogin());
  };

  const login = async () => {
    const result = await loginUser(dispatch, values, history);
    if (result?.mfaRequired) {
      history.push(`/mfa/${result.nextStep}`, { mfaToken: result.token, mode: result.nextStep === 'enroll' ? 'enrollment' : 'verification' });
    }
  };

  const onSubmit = (e) => { e.preventDefault(); login(); };

  const subtitle = hasError
    ? (errorMessage || "Mot de passe erroné. En cas d'oublie, contactez-nous")
    : "Utiliser les identifiants fournis par COPIMA pour accéder";

  return (
    <>
      {status === 'loading' && <GlobalLoader size="100vh" />}
      <AuthLayout>
        <AuthCard title="Connexion" subtitle={subtitle} hasError={hasError}>
          <form noValidate autoComplete="off" onSubmit={onSubmit} style={{ width: '100%' }}>
            <RenderOnDemandThenHide visible={!firstLogin?.isFirstLogin}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '40px', mt: '30px', width: '100%' }}>

                <LabeledField label="Identifiant :">
                  <TextField
                    fullWidth

                    value={values.username}
                    onChange={handleChange('username')}
                    error={hasError}
                    sx={fieldSx}
                  />
                </LabeledField>

                <LabeledField label="Mot de passe :">
                  <TextField
                    fullWidth

                    type={values.showPassword ? 'text' : 'password'}
                    value={values.password}
                    onChange={handleChange('password')}
                    error={hasError}
                    sx={fieldSx}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setValues({ ...values, showPassword: !values.showPassword })} onMouseDown={(e) => e.preventDefault()} edge="end" size="small">
                            {values.showPassword ? <img src={eyeicon} alt="hide" style={{ width: 20, height: 20 }} />
                            : <img src={eyeicon} alt="show" style={{ width: 25, height: 20 }} />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </LabeledField>

              </Box>

              <AuthButton type="submit" sx={{ mt: '0px' }}>Se connecter</AuthButton>
            </RenderOnDemandThenHide>

            <RenderOnDemandThenHide visible={firstLogin?.isFirstLogin}>
              <ChangePassword dispatch={dispatch} />
            </RenderOnDemandThenHide>
          </form>
        </AuthCard>
      </AuthLayout>

    </>
  );
};

Login.propTypes = {};
export default Login;
